import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import categoriesAdapter from './categories.adapter';
import { Category, CategoryState } from './types';

const initialState: CategoryState = {
  ids: [],
  entities: {},
};

export const { reducer, actions } = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    getCategoriesSuccess: (state, action: PayloadAction<Category[]>) => {
      categoriesAdapter.setAll(state, action.payload);
    },
    getCategoriesFailed: state => {
      categoriesAdapter.setAll(state, []);
    },
  },
  extraReducers: {},
});
